import { useEffect } from "react";
import PageHeader from "@/components/marketing/PageHeader";
import Asphalt from "@/components/marketing/Asphalt";
import Reveal from "@/components/Reveal";
import { IMG } from "@/data/content";
import { BTN_PRIMARY } from "@/lib/ui";
import { trackEvent } from "@/lib/tracking";
import { Mail } from "lucide-react";

export default function AsphaltPage() {
  useEffect(() => {
    trackEvent("page_view", { label: "asphalt-sales" });
  }, []);

  return (
    <div data-testid="asphalt-page">
      <PageHeader
        overline="High-Quality Asphalt Production"
        crumb="FOB Asphalt Sales"
        title="FOB Asphalt Sales"
        subtitle="Ranger provides the highest quality FOB asphalt products on all our jobs and to all our customers — pick up from the plant nearest your job location."
        image={IMG.asphaltBanner}
      />

      <Asphalt />

      <section className="bg-rc-bg py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal className="bg-rc-charcoal rounded-2xl p-8 lg:p-12 flex flex-col lg:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="font-heading font-black text-white text-2xl lg:text-3xl">Need current pricing?</h3>
              <p className="text-white/65 mt-2 max-w-xl">
                Contact the plant nearest your job, or reach our team for pricing and pickup information.
              </p>
            </div>
            <a href="mailto:estimating@rangerconstruction.com" data-testid="asphalt-pricing-cta" className={BTN_PRIMARY}>
              <Mail size={17} /> Request Pricing
            </a>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
